export const commissionerAgreementContract = {
  listApi: '/represent/representAgreement/list',
  filterType: 'represent_agreement',
  exportType: 'representAgreement',
  entityBelongId: 'partner_commissioner_agreement',
  routePath: '/projectForPartner/commissionerManagement/cooperationAgreement',
} as const;

export const COMMISSIONER_AGREEMENT_BATCH_LIMIT = 200;

type AgreementListParams = Record<string, unknown>;

interface AgreementExportSelection {
  id?: string | number;
  ids?: Array<string | number>;
  representName?: string;
}

export function buildCommissionerAgreementListParams(pageParams: AgreementListParams, filterParams: AgreementListParams, mergeSearchField: string) {
  return {
    ...pageParams,
    ...filterParams,
    column: 'signTime',
    order: 'desc',
    mergeSearchField,
  };
}

export function buildCommissionerAgreementExportParams(selection: AgreementExportSelection) {
  return {
    asyncTaskType: 'commonExport',
    paramDto: {
      superQueryMatchType: '',
      superQueryParams: '',
      mergeSearchField: '',
    },
    exportConfig: '',
    fileFormat: '',
    otherConfig: {},
    approveStatusList: [],
    commonExportType: commissionerAgreementContract.exportType,
    ...selection,
  };
}

export function exceedsCommissionerAgreementBatchLimit(count: number) {
  return count > COMMISSIONER_AGREEMENT_BATCH_LIMIT;
}
